import { useState } from 'react'

import { Tabs } from '@/components/core-v2'

export interface GroupedTab {
  component: any
  heading: string
  value: string
}

type NonEmptyArray<T> = [T, ...T[]]

export interface GroupedTabsProps {
  label: string
  tabs: NonEmptyArray<GroupedTab>
}

export const GroupedTabsPanel = ({ label, tabs }: GroupedTabsProps) => {
  const [tabValue, setTabValue] = useState(tabs[0].value)
  const selectedTab = tabs.filter(tab => tab.value === tabValue)?.[0]
  return (
    <>
      <Tabs.List aria-label={label} className="ml-4" spacing="sm">
        {tabs.map(tab => (
          <Tabs.Tab
            key={tab.value}
            isSelected={tab.value === tabValue}
            value={tab.value}
            onClick={() => setTabValue(tab.value)}
          >
            {tab.heading}
          </Tabs.Tab>
        ))}
      </Tabs.List>
      <Tabs.Panel className="flex-1 flex flex-column" value={tabValue}>
        {selectedTab?.component}
      </Tabs.Panel>
    </>
  )
}
